<template>
    <f7-page name="location">
        <bc-navbar></bc-navbar>
        <br/>
        <div v-bind:class="{ none: !isRequestActive }" class="loader">
            <looping-rhombuses-spinner :animation-duration="1500" :rhombus-size="15" :style="{ 'color': customization.mainColor }" />
        </div>
        <div class="logo_on_map">
            <div>
                <img :src='logo'>
            </div>
        </div>
        <div class="layout_fullwidth_padding">
            <h3>Our Location</h3>           
            <iframe class="map" :src="mapUrl" allowfullscreen=""></iframe>
            <blockquote :style="borderStyle">
                <b>Adress: </b> {{adress}}
            </blockquote>
            <h3>Hours of Operation</h3>
            <table>
                <tr>
                    <th :style="borderStyle">Day</th>
                    <th :style="borderStyle">Hours</th>
                </tr>
                <tr v-if="this.workHours.Mf!=undefined">
                    <td>{{this.workHours.Mf.name}}</td>
                    <td>{{this.workHours.Mf.time}}</td>
                </tr>
                <tr v-if="this.workHours.Sat!=undefined">
                    <td>{{this.workHours.Sat.name}}</td>
                    <td>{{this.workHours.Sat.time}}</td>
                </tr>
                <tr v-if="this.workHours.Sun!=undefined">
                    <td>{{this.workHours.Sun.name}}</td>
                    <td>{{this.workHours.Sun.time}}</td>
                </tr>
            </table>

        </div>
    </f7-page>
</template>

<script>
/* eslint-disable */
import { mapState,mapGetters,mapActions } from 'vuex'
import { LoopingRhombusesSpinner  } from 'epic-spinners'
import {Request} from '../../shared/base.requests'
import config from '../../../config/customer.api'
import {appInsights} from '../../shared/applicationInsights'


export default {
    //Lifecycle
    components:{
        LoopingRhombusesSpinner 
    },
    mounted:function(){
        this.isRequestActive = true;
        this.$store.dispatch('aboutCompany/loadDataByCompany')
            .then(()=>{
                this.isRequestActive = false;
                var params = this.companyData.adress.replace(" ", "-") + ",+" + this.companyData.city + ",+" + this.companyData.state + "+" + this.companyData.zip;
                this.adress = this.companyData.adress + ", " + this.companyData.city + ", " + this.companyData.state + ", " + this.companyData.zip;
                this.mapUrl ="https://www.google.com/maps?q="+params+"&ie=UTF8&hq=&hnear="+params+"&t=m&z=16&iwloc=A&output=embed";
                this.workHours = JSON.parse(this.companyData.operationHours);
                
                var splitSpaceIndex = this.workHours.Mf.search(/[^-] [^-]/)+1;
                var value = this.workHours.Mf;
                this.workHours.Mf = {};
                this.workHours.Mf.name = value.substring(0,splitSpaceIndex);
                this.workHours.Mf.time = value.substring(splitSpaceIndex+1,value.length);

                splitSpaceIndex = this.workHours.Sat.search(/[^-] [^-]/)+1;
                value = this.workHours.Sat;
                this.workHours.Sat = {};
                this.workHours.Sat.name = value.substring(0,splitSpaceIndex);
                this.workHours.Sat.time = value.substring(splitSpaceIndex+1,value.length);

                splitSpaceIndex = this.workHours.Sun.search(/[^-] [^-]/)+1;
                value = this.workHours.Sun;
                this.workHours.Sun = {};
                this.workHours.Sun.name = value.substring(0,splitSpaceIndex);
                this.workHours.Sun.time = value.substring(splitSpaceIndex+1,value.length);
                if(this.workHours.Sun.time.indexOf("Sun")!=-1)
                {
                    var temp = this.workHours.Sun.time;
                    this.workHours.Sun.time = this.workHours.Sun.name;
                    this.workHours.Sun.name = temp;
                }
                console.log(this.workHours.Sun);
            }).catch(x=> {
                appInsights.trackException({ exception: x, properties: { 'info': 'error during loadDataByCompany result processing'}});
                appInsights.flush();
                this.$f7.mainView.router.load({url: 'error'});
    });
    },
    methods:{
        redirectWithActivity (url,type) { 
            if(url){
                if(type)
                Request.get(config.logCustomerActivity+type);  
                return window.location = url;
            } 
        },
        LogActivity(type){
            if(type)
             Request.get(config.logCustomerActivity+type);  
        }
    },
    computed:{
        ...mapState({
                companyData: state => state.aboutCompany.companyData,   
                phone: state => state.common.phone,
                isDemoUser :  state => state.editUserProfile.customerUser.isDemoUser,
                logo: state => state.common.logo,
                customization: state => state.common.customization
            }),
            borderStyle: function(){     
                var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor :  'none';
                var backgroundStyle = this.customization.mainColor;
                var colorStyle = this.customization.fontColor
                return {
                    border: borderStyle, 
                    background: backgroundStyle,
                    color:colorStyle
                };
            }
        },
    data() {
        return{
            isRequestActive:false,
            mapUrl:"",
            workHours:{
                Mf:undefined,
                Sat:undefined,
                Sun:undefined
            },
            adress:""
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map{
    width:100%;
    height:270px;
}
.loader{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background:  rgb(255, 255, 255);
}
.none{
    display: none;
}
.btgreen{
    background-color: #77ba82;
    color: #ffffff;
}
table{
    width:100%;
    margin-bottom:20px
}
td{
    padding:10px;    
    background:#f2f2f2
}
th{
    background-color: #f9f301;
    font-weight: bold;
    padding:10px;    
}

</style>



// WEBPACK FOOTER //
// about-company.vue?99cfeb1c